import { render, staticRenderFns } from "./ReviewItem.vue?vue&type=template&id=a13a80a4&scoped=true&"
import script from "./ReviewItem.vue?vue&type=script&lang=js&"
export * from "./ReviewItem.vue?vue&type=script&lang=js&"
import style0 from "./ReviewItem.vue?vue&type=style&index=0&id=a13a80a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13a80a4",
  null
  
)

export default component.exports